import { aiType } from "@/types.d";
import { formatFileSize } from "@/utils/common";

const typeTransform = (type) => {
  // 这里图片转文字和语音转文字需要做类型转换才能在购买页进行服务匹配
  const isNeedTransformType = ["ai_ocr", "ai_nls"].includes(type);
  const needTransformTypeMap = {
    ai_ocr: "ocr",
    ai_nls: "nls",
  };

  return isNeedTransformType ? needTransformTypeMap[type] : type;
};

const gotoBuyLinkAdded = (type) => {
  window.open(`/rm/payment/redirect?type=${type}_type`);
};

const gotoBuyLinkInvest = () => {
  window.open("/rm/payment/deposit");
};

const gotoService = () => {
  window.open("/rm/team/service");
};

const gotoPriceUpdate = () => {
  window.open("/rm/pricing");
};

enum ServiceType {
  OCR = "ai_ocr",
  TTS = "tts",
  NLS = "ai_nls",
  IMAGE_SLIM = "image_slim",
  IMAGE_ENHANCEMENT = "image_enhancement",
  IMAGE_ENLARGEMENT = "image_enlargement",
  IMAGE_COLORIZE = "image_colorize",
  TEXT_GENERATED_IMAGE = "text_generated_image",
  TEXT_CORRECT_TYPE = "text_error_correction",
  INTELLIGENCE_ARTICLE = "intelligence_article",
  AUDIO_EVALUATION = "audio_evaluation",
  IMAGE_MATTING = "image_matting",
  PORTRAIT_STYLE_REPAINTING = "portrait_style_repainting",
  INTELLIGENCE_WORDART = "intelligence_wordart",
  RECOGNIZE_HANDWRITING = "recognize_handwriting",
  IMAGE_CROPPING = "image_cropping",
}

const serviceNameMap = {
  [ServiceType.OCR]: "图片转文字",
  [ServiceType.TTS]: "语音合成",
  [ServiceType.NLS]: "语音转文字",
  [ServiceType.IMAGE_SLIM]: "图片智能压缩",
  [ServiceType.IMAGE_ENHANCEMENT]: "图片智能清晰",
  [ServiceType.IMAGE_ENLARGEMENT]: "图片智能放大",
  [ServiceType.IMAGE_COLORIZE]: "图片智能上色",
  [ServiceType.TEXT_GENERATED_IMAGE]: "文本生成图像",
  [ServiceType.TEXT_CORRECT_TYPE]: "智能文本校对",
  [ServiceType.INTELLIGENCE_ARTICLE]: "智能文本处理",
  [ServiceType.AUDIO_EVALUATION]: "API-语音评测",
  [ServiceType.RECOGNIZE_HANDWRITING]: "API-手写识别",
  [ServiceType.IMAGE_MATTING]: "智能抠图",
  [ServiceType.PORTRAIT_STYLE_REPAINTING]: "人物风格重绘",
  [ServiceType.INTELLIGENCE_WORDART]: "智能艺术字",
  [ServiceType.IMAGE_CROPPING]: "图片智能裁切",
};

const useGetIdentifyInfo = (type: aiType, getIdentifyHook, vueHook) => {
  const h = vueHook.$createElement;
  const identifyInfo = {
    cloud_type: "",
    service_status: "",
    mode: "",
    detail: {},
    deduct_status: 0,
    quota_status: 0,
    user_type: 0,
    unit_price: "",
    balance_remain_number: 0,
    balance_remain_number_desc: "",
    balance_deduct_number: 0,
    balance_deduct_number_desc: "",
  };
  return new Promise((resolve, reject) => {
    getIdentifyHook(type, {
      type,
    })
      .then((res) => {
        if (res.status === 0) {
          identifyInfo.cloud_type = res.data?.cloud_type;
          identifyInfo.service_status = res.data?.service_status;
          identifyInfo.mode = res.data?.mode;
          identifyInfo.deduct_status = res.data?.deduct_status;
          identifyInfo.quota_status = res.data?.quota_status;
          identifyInfo.user_type = res.data?.user_type;
          identifyInfo.unit_price = res.data?.unit_price;
          identifyInfo.balance_remain_number = res.data?.balance_remain_number;
          identifyInfo.balance_remain_number_desc =
            res.data?.balance_remain_number_desc;
          identifyInfo.balance_deduct_number = res.data?.balance_deduct_number;
          identifyInfo.balance_deduct_number_desc =
            res.data?.balance_deduct_number_desc;
          identifyInfo.detail = res.data.detail;

          // if (identifyInfo.cloud_type !== 'mugeda' && identifyInfo.service_status !== 'normal') {
          //    window.Message && window.Message.error('服务使用已超限');
          // }

          if (identifyInfo.user_type === 0) {
            // 免费用户单独处理
            if (identifyInfo.service_status !== "normal") {
              window.MessageBox &&
                window.MessageBox.confirm(
                  `${serviceNameMap[type]}的免费使用额度已用尽，您在升级会员后可以购买套餐，并享受到更好的会员服务。`,
                  "提示",
                  {
                    confirmButtonText: "去升级",
                    cancelButtonText: "关闭",
                    customClass: "use-identify-message-box",
                  }
                )
                  .then(() => {
                    gotoPriceUpdate();
                  })
                  .catch(() => {});
            }
          } else if (
            identifyInfo.user_type !== null &&
            identifyInfo.user_type !== undefined
          ) {
            if (identifyInfo.deduct_status) {
              // 开启余额抵扣
              // 根据不同余额类型显示不同提示
              if (identifyInfo.unit_price.indexOf("次") > -1) {
                if (identifyInfo.balance_remain_number < 10) {
                  vueHook
                    .$msgbox({
                      message: h("div", null, [
                        h(
                          "p",
                          null,
                          `您余额的预计可使用额度已不足10次，您是否要继续充值使用服务？`
                        ),
                        h(
                          "p",
                          null,
                          `您也可以单独购买${serviceNameMap[type]}的服务套餐。`
                        ),
                      ]),
                      title: "提示",
                      customClass: "use-identify-message-box",
                      showCancelButton: true,
                      distinguishCancelAndClose: true,
                      confirmButtonText: "去购买套餐",
                      cancelButtonText: "去充值",
                    })
                    .then((action) => {
                      gotoBuyLinkAdded(type);
                    })
                    .catch((action) => {
                      if (action === "cancel") {
                        gotoBuyLinkInvest();
                      }
                    });
                }
              } else if (identifyInfo.unit_price.indexOf("秒") > -1) {
                if (identifyInfo.balance_remain_number < 180) {
                  vueHook
                    .$msgbox({
                      message: h("div", null, [
                        h(
                          "p",
                          null,
                          `您余额的预计可使用额度已不足3分钟，您是否要继续充值使用服务？`
                        ),
                        h(
                          "p",
                          null,
                          `您也可以单独购买${serviceNameMap[type]}的服务套餐。`
                        ),
                      ]),
                      title: "提示",
                      customClass: "use-identify-message-box",
                      showCancelButton: true,
                      distinguishCancelAndClose: true,
                      confirmButtonText: "去购买套餐",
                      cancelButtonText: "去充值",
                    })
                    .then((action) => {
                      gotoBuyLinkAdded(type);
                    })
                    .catch((action) => {
                      if (action === "cancel") {
                        gotoBuyLinkInvest();
                      }
                    });
                }
              } else {
                if (identifyInfo.balance_remain_number < 10 * 1024 * 1024) {
                  vueHook
                    .$msgbox({
                      message: h("div", null, [
                        h(
                          "p",
                          null,
                          `您余额的预计可使用额度已不足10M，您是否要继续充值使用服务？`
                        ),
                        h(
                          "p",
                          null,
                          `您也可以单独购买${serviceNameMap[type]}的服务套餐。`
                        ),
                      ]),
                      title: "提示",
                      customClass: "use-identify-message-box",
                      showCancelButton: true,
                      distinguishCancelAndClose: true,
                      confirmButtonText: "去购买套餐",
                      cancelButtonText: "去充值",
                    })
                    .then((action) => {
                      gotoBuyLinkAdded(type);
                    })
                    .catch((action) => {
                      if (action === "cancel") {
                        gotoBuyLinkInvest();
                      }
                    });
                }
              }
            } else {
              // 是否使用套餐
              if (
                identifyInfo.mode === "undeduct" ||
                identifyInfo.mode === "package"
              ) {
                if (
                  !sessionStorage.getItem(`isCheckDeduct_${type}`) &&
                  identifyInfo.detail &&
                  identifyInfo.detail?.used_number /
                    identifyInfo.detail?.total_number >
                    0.95 &&
                  identifyInfo.detail?.used_number /
                    identifyInfo.detail?.total_number <
                    1
                ) {
                  vueHook
                    .$msgbox({
                      message: h("div", null, [
                        h(
                          "p",
                          null,
                          `${serviceNameMap[type]}的套餐剩余量已不足
                        ${
                          identifyInfo.unit_price.indexOf("次") > -1
                            ? identifyInfo.detail?.total_number -
                              identifyInfo.detail?.used_number +
                              "次"
                            : formatFileSize(
                                identifyInfo.detail?.total_number -
                                  identifyInfo.detail?.used_number
                              )
                        }
                        ，您是否要购买套餐？`
                        ),
                        h(
                          "p",
                          null,
                          `您也可开启${serviceNameMap[type]}的余额抵扣功能，它可以帮助您在服务套餐用尽后，自动无缝切换到余额抵扣模式，继续保持您和您的团队能正常使用服务，避免在紧急情况下服务中断、无法使用的问题。`
                        ),
                        h(
                          "p",
                          null,
                          `同时，多个不同服务的抵扣功能可共用余额，减少您为不同服务购买套餐的繁复操作。`
                        ),
                        h("p", null, `您可以额随时关闭余额抵扣功能。`),
                      ]),
                      title: "提示",
                      customClass: "use-identify-message-box",
                      showCancelButton: true,
                      distinguishCancelAndClose: true,
                      confirmButtonText: "去购买套餐",
                      cancelButtonText: "开启余额抵扣",
                    })
                    .then((action) => {
                      gotoBuyLinkAdded(type);
                    })
                    .catch((action) => {
                      if (action === "cancel") {
                        gotoService();
                      }
                    });
                } else if (identifyInfo.service_status !== "normal") {
                  vueHook
                    .$msgbox({
                      message: h("div", null, [
                        h(
                          "p",
                          null,
                          `${serviceNameMap[type]}的套餐已用尽，您是否要购买套餐？`
                        ),
                        h(
                          "p",
                          null,
                          `您也可开启${serviceNameMap[type]}的余额抵扣功能，它可以帮助您在服务套餐用尽后，自动无缝切换到余额抵扣模式，继续保持您和您的团队能正常使用服务，避免在紧急情况下服务中断、无法使用的问题。`
                        ),
                        h(
                          "p",
                          null,
                          `同时，多个不同服务的抵扣功能可共用余额，减少您为不同服务购买套餐的繁复操作。`
                        ),
                        h("p", null, `您可以额随时关闭余额抵扣功能。`),
                      ]),
                      title: "提示",
                      customClass: "use-identify-message-box",
                      showCancelButton: true,
                      distinguishCancelAndClose: true,
                      confirmButtonText: "去购买套餐",
                      cancelButtonText: "开启余额抵扣",
                    })
                    .then((action) => {
                      gotoBuyLinkAdded(type);
                    })
                    .catch((action) => {
                      if (action === "cancel") {
                        gotoService();
                      }
                    });
                }
              } else {
                if (identifyInfo.service_status !== "normal") {
                  vueHook
                    .$msgbox({
                      message: h("div", null, [
                        h(
                          "p",
                          null,
                          `${serviceNameMap[type]}的额度已用尽，您是否要购买套餐？`
                        ),
                        h(
                          "p",
                          null,
                          `您也可开启${serviceNameMap[type]}的余额抵扣功能，它可以帮助您在服务套餐用尽后，自动无缝切换到余额抵扣模式，继续保持您和您的团队能正常使用服务，避免在紧急情况下服务中断、无法使用的问题。`
                        ),
                        h(
                          "p",
                          null,
                          `同时，多个不同服务的抵扣功能可共用余额，减少您为不同服务购买套餐的繁复操作。`
                        ),
                        h("p", null, `您可以额随时关闭余额抵扣功能。`),
                      ]),
                      title: "提示",
                      customClass: "use-identify-message-box",
                      showCancelButton: true,
                      distinguishCancelAndClose: true,
                      confirmButtonText: "去购买套餐",
                      cancelButtonText: "开启余额抵扣",
                    })
                    .then((action) => {
                      gotoBuyLinkAdded(type);
                    })
                    .catch((action) => {
                      if (action === "cancel") {
                        gotoService();
                      }
                    });
                }
              }
            }
          }
          if (!sessionStorage.getItem(`isCheckDeduct_${type}`)) {
            sessionStorage.setItem(`isCheckDeduct_${type}`, "1");
          }
          resolve(identifyInfo);
        } else {
          Message && Message(res.description);
          reject();
        }
      })
      .catch((error) => {
        console.log("error :>> ", error);
      });
  });
};

export { useGetIdentifyInfo };
